var isValid = require('date-fns/is_valid')

function ensureDateString(val) {
  if (typeof val === 'string' && isValid(new Date(val))) return val
  if (Object.prototype.toString.call(val) === '[object Date]' && isValid(val))
    return val.toISOString()
  return ''
}

module.exports = ensureDateString
